import { useCallback } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";

import { useRefreshAction } from "@/features/dashboard/features/refresh-timer/hooks";
import { useDashboardData } from "@/features/shared/hooks";

import {
  fetchRiskPictureWarningSets,
  riskPictureWarningSetsKey,
} from "./risk-picture-warning-sets";

/** Land warning sets. Outside the refresh provider this only reads the cache. */
export function useRiskPictureWarningSetsQuery(options?: { enabled?: boolean }) {
  const { selectedDashboard } = useDashboardData();
  const dashboardId = selectedDashboard?.id;
  const queryClient = useQueryClient();
  const enabled = Boolean(dashboardId) && (options?.enabled ?? true);

  const refresh = useCallback(async () => {
    if (!enabled) return;
    await queryClient.refetchQueries({ queryKey: riskPictureWarningSetsKey() });
  }, [enabled, queryClient]);
  useRefreshAction(refresh);

  return useQuery({
    queryKey: riskPictureWarningSetsKey(),
    queryFn: fetchRiskPictureWarningSets,
    enabled,
  });
}
